module.exports = __webpack_public_path__ + "static/careRating2-3e46eca6bb151eaebf050ab870ec0723.svg";